import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PriceListAccommodation } from '../../../models/pricelist-accommodation.model';
import { AccommodationTableLabels, AccommodationDataTable, AccommodationOptionsDataTable } from '../../../models/types';
import { CompanyEnum } from '../../../models/company.model';
import { PricePipe } from '@lx/shared/ui/pipes';
import { TableModule } from 'primeng/table';
import { getAccommodationsLabels } from '../../../utils/table-utils';

@Component({
  standalone: true,
  imports: [CommonModule, PricePipe, TableModule],
  selector: 'lx-price-lists-portal-positively-languages-accommodation-table',
  templateUrl: './positively-languages-accommodation-table.component.html',
  styleUrls: ['./positively-languages-accommodation-table.component.scss'],
})
export class PositivelyLanguagesAccommodationTableComponent implements OnInit {
  @Input() accommodations: PriceListAccommodation | undefined;
  @Input() notationMarks: Record<string, string> | undefined;

  dataSource: AccommodationDataTable[] = [];
  companyEnum = CompanyEnum;

  readonly columnLabels: AccommodationTableLabels = getAccommodationsLabels(CompanyEnum.KIL);

  ngOnInit(): void {
    this.dataSource = this.accommodations?.products.reduce<AccommodationDataTable[]>((accommodations, { name, options: productOptions, noteCode }) => {
      const options = productOptions.reduce<AccommodationOptionsDataTable[]>((opts, { roomType: type, meals, bathroom, minAge, prices, noteCode }) => {
        return [
          ...opts,
          {
            type,
            meals,
            bathroom,
            minAge,
            noteCode,
            price: prices ? prices.find((p) => p.price).price : null,
          },
        ];
      }, []);
      return [
        ...accommodations,
        {
          name,
          options,
          noteCode,
        },
      ];
    }, []);
  }
}
